import { PluginKey } from 'prosemirror-state'
import { State } from './Types'

export const EMOJI_PLUGIN_KEY = new PluginKey<State>('emoji')

export const ANCHOR_DATA_ATTR = 'data-emoji-anchor'

export const SELECT_KEYS = ['Enter', 'Tab']
